(() => {
  const query = `mutation BundleQuotes($two: CartInput!, $four: CartInput!, $six: CartInput!) {
    p2: cartCreate(input: $two) { cart { totalQuantity cost { subtotalAmount { amount currencyCode } } } userErrors { message } }
    p4: cartCreate(input: $four) { cart { totalQuantity cost { subtotalAmount { amount currencyCode } } } userErrors { message } }
    p6: cartCreate(input: $six) { cart { totalQuantity cost { subtotalAmount { amount currencyCode } } } userErrors { message } }
  }`;
  function init() {
    const root = document.querySelector('#anessa-product');
    if (!root || root.dataset.marketPricesReady) return;
    root.dataset.marketPricesReady = 'true';
    const product = JSON.parse(root.querySelector('[data-anessa-product]').textContent);
    const country = root.dataset.country;
    const currency = root.dataset.currency;
    const money = new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency,currencyDisplay:'symbol'});
    const packs = [...root.querySelectorAll('[data-pack]')];
    const status = root.querySelector('[data-price-status]');
    const retry = root.querySelector('[data-price-retry]');
    let revision = 0, timer, controller;
    const setStatus = message => {status.textContent = message; status.hidden = !message;};
    async function refresh() {
      const current = ++revision;
      controller?.abort(); controller = new AbortController();
      const requestController = controller;
      retry.hidden = true;
      const variables = {};
      for (const pack of packs) {
        const quantity = Number(pack.dataset.pack);
        const lines = [...pack.querySelectorAll('.an-variant-row')].map(row => {
          const color = row.querySelector('input:checked')?.value;
          const size = row.querySelector('select').value;
          const variant = product.variants.find(v => v.option1 === color && v.option2 === size);
          return variant?.available ? {merchandiseId:`gid://shopify/ProductVariant/${variant.id}`,quantity:1} : null;
        });
        if (lines.some(line => !line)) {setStatus('Choose available sizes to see current prices.');return;}
        variables[{2:'two',4:'four',6:'six'}[quantity]] = {buyerIdentity:{countryCode:country},lines};
      }
      // Separate Storefront carts quote the discounts without touching the shopper's Ajax cart.
      setStatus('Updating local prices…');
      const timeout = setTimeout(() => requestController.abort(), 12000);
      try {
        const response = await fetch('/api/2026-07/graphql.json', {
          method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({query,variables}),signal:requestController.signal
        });
        if (!response.ok) throw new Error('Prices unavailable');
        const result = await response.json();
        if (result.errors?.length) throw new Error('Prices unavailable');
        const quotes = packs.map(pack => {
          const quantity = Number(pack.dataset.pack);
          const payload = result.data?.[`p${quantity}`];
          const amount = payload?.cart?.cost?.subtotalAmount;
          const total = Number(amount?.amount);
          if (payload?.userErrors?.length || payload?.cart?.totalQuantity !== quantity || amount?.currencyCode !== currency || !Number.isFinite(total) || total <= 0) throw new Error('Invalid quote');
          return {pack,quantity,total};
        });
        if (current !== revision || !root.isConnected) return;
        for (const {pack,quantity,total} of quotes) {
          pack.querySelector('[data-pack-total]').textContent = money.format(total);
          pack.querySelector('[data-each]').textContent = money.format(total / quantity);
          pack.querySelector('[data-each]').parentElement.hidden = false;
        }
        root.dataset.pricesVerified = currency;
        setStatus('');
      } catch (error) {
        if (current !== revision || !root.isConnected) return;
        // Never relabel a USD amount as a foreign currency when Shopify cannot quote it.
        if (currency !== 'USD') packs.forEach(pack => {
          pack.querySelector('[data-pack-total]').textContent = 'See cart';
          pack.querySelector('[data-each]').parentElement.hidden = true;
        });
        setStatus('Local prices will be confirmed in your cart.');
        retry.hidden = false;
      } finally {clearTimeout(timeout);}
    }
    root.addEventListener('change', event => {
      if (!event.target.closest('.an-variant-row')) return;
      clearTimeout(timer); timer = setTimeout(refresh, 250);
    });
    retry.addEventListener('click',refresh);
    refresh();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  document.addEventListener('shopify:section:load',init);
})();
